import React, { useState, useEffect } from "react";
import { Container, Card, CardBody } from "reactstrap";
import { isEmpty } from "lodash";
import ErrorBoundary from "components/ErrorBoundary";
import SearchContainer from "./components/SearchContainer";
import LocationTable from "./components/LocationTable";
import API from "utils/API";
import { onExport, getUpdatedFilter } from "utils/helper";
import { find } from "lodash";

const initialFilterBySearch = {
  coveredEntityName: "",
};

let coveredEntityTenantID = "";
let coveredEntityID = "";
let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: "",
  order: "",
  filters: [],
};

let selectedCoveredEntity = {};

const Location = () => {
  const [state, updateState] = useState({
    data: [],
    coveredEntity: [],
    loading: false,
    selectedEntity: "",
    coveredId: "",
    records: 0,
    reset: false,
  });

  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  useEffect(() => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: "",
      order: "",
      filters: [],
    };
    setState({ data: [], records: 0 });
    selectedCoveredEntity = {};
  }, [])

  const fetchLocations = async (pageDetails = {}, hasColumnFilter) => {
    setState({ loading: true });
    let filter = { ...pageDetails };
    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      initialFilters.filters = [...initialFilters.filters];
    } else {
      initialFilters = { ...initialFilters, ...filter };
    }
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    try {
      const result = await API.post(
        `/${tenantID}/CEServiceLocation/All/${coveredEntityID}`,
        filter
      );
      if (result.data) {
        setState({
          data: result.data.items,
          records: result.data.totalRecords,
          loading: false,
        });
      }
    } catch (error) {
      setState({ loading: false, data: [], records: 0 });
    }
  };

  const onSearchLocation = async (filters) => {
    const { coveredEntityName } = filters;
    if (coveredEntityName && !isEmpty(coveredEntityName)) {
      initialFilters.filters = getUpdatedFilter(
        "coveredEntityID",
        parseInt(coveredEntityName),
        initialFilters
      );
      initialFilters.currentPage = 1;
      fetchLocations(initialFilters);
    }
  };

  const onReset = () => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: "",
      order: "",
      filters: [],
    };
    setState({ data: [], reset: !state.reset, records: 0 });
    selectedCoveredEntity = {};
  };

  const handleExport = () => {
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/CEServiceLocation/ExportAll/${coveredEntityID}?access_token=${access_token}`;
    onExport(action, initialFilters);
  };

  const onPageChange = (filter, hasFilter) => {
    if (hasFilter) {
      fetchLocations(filter, true);
    } else {
      fetchLocations(filter);
    }
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    await fetchLocations({ ...initialFilters, ...columnFilters }, true);
  };

  const handleUpdateEntity = (entity) => {
    selectedCoveredEntity = entity;
  };

  const refetch = (hasReset) => {
    if (hasReset) {
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
      };
    }
    fetchLocations(initialFilters);
  };

  return (
    <div>
      <Container fluid className="my-3">
        <Card className="border-0 shadow-top">
          <CardBody className="section-devider-border">
            <ErrorBoundary>
              <SearchContainer
                initialValue={initialFilterBySearch}
                onSearch={onSearchLocation}
                onReset={onReset}
                handleUpdateEntity={handleUpdateEntity}
              />
            </ErrorBoundary>
          </CardBody>
          <CardBody className="pt-0">
            <ErrorBoundary>
              <LocationTable
                data={state.data}
                loading={state.loading}
                onExport={handleExport}
                filters={initialFilters}
                totalSize={state.records}
                onPageChange={onPageChange}
                coveredEntityID={selectedCoveredEntity.coveredEntityID}
                tenantID={selectedCoveredEntity.tenantID}
                setLoading={(value) => setState({ loading: value })}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                reset={state.reset}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Location;
